import { Component, OnInit } from '@angular/core';

@Component({  
    template: `
 <div style="text-align: center; height: 100vh;">
    <iframe
      src="../../../assets/privacy-policies/Privacy Policy_CestApp - Driver.pdf"
      width="100%"
      height="100%"
      style="border: none;"
      title="Privacy Policy"
    ></iframe>
  </div>
  `,
})

export class PoliciesPageComponent {

    constructor() { }

    ngOnInit() {
    }

}
